<template>
  <ion-list v-if="resources != null">
    <div
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
    >
      <ion-item v-if="item.roles[0].name == 'teacher'" class="hydrated link">
        <ion-label @click="openPopover(item, $event)">
          <h2>{{ item.user_detail.name }}</h2>
        </ion-label>
      </ion-item>
    </div>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No teachers found</p>
    </ion-list-header>
  </ion-list>
  <ion-modal
    :is-open="updateModalState"
    @didDismiss="setUpdateModalState(false)"
  >
    <base-modal
      title="Update Teacher Profile"
      @closeModal="setUpdateModalState(false)"
    >
      <update-teacher
        @closeModal="setUpdateModalState(false)"
        :resource="resourceToUpdate"
      ></update-teacher>
    </base-modal>
  </ion-modal>

  <ion-popover
    :is-open="popoverState"
    :event="popoverEvent"
    @didDismiss="setPopoverState(false)"
  >
    <base-popover
      @closePopover="setPopoverState(false)"
      :title="selectedResource.user_detail.name"
    >
      <ion-item button @click="setResourceToUpdate(selectedResource.id)"
        >Edit</ion-item
      >
    </base-popover>
  </ion-popover>
</template>
<script>
import BaseModal from "../../../Base/BaseModal";
import UpdateTeacher from "../Teacher/UpdateTeacher";
import BasePopover from "../../../Base/BasePopover.vue";
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonModal,
  IonPopover,
} from "@ionic/vue";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonPopover,
    BasePopover,
    IonModal,
    BaseModal,
    UpdateTeacher,
  },
  data() {
    return {
      popoverState: false,
      popoverEvent: null,
      selectedResource: null,
      updateModalState: false,

      resourceToUpdate: {
        id: null,
        name: null,
      },
    };
  },
  methods: {
    slide(id) {
      this.$refs[`items-${id}`].$el.open();
    },

    setUpdateModalState(state) {
      this.updateModalState = state;
      if (state == false) {
        this.setPopoverState(false);
      }
    },

    setResourceToUpdate(id) {
      const resource = this.resources.data.find(
        (resource) => resource.id === id
      );
      this.resourceToUpdate = resource;
      this.setUpdateModalState(true);
    },

    openPopover(resource, ev) {
      this.popoverEvent = ev;
      this.setSelectedResource(resource);
      this.setPopoverState(true);
    },

    setPopoverState(state) {
      this.popoverState = state;
    },

    setSelectedResource(resource) {
      this.selectedResource = resource;
    },
  },
};
</script>
